import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timestamp"]

  connect() {
    this.render()
  }

  render() {
    this.timestampTargets.forEach((element) => {
      const iso = element.dataset.localTimeIso
      if (!iso) return

      const date = new Date(iso)
      if (Number.isNaN(date.getTime())) return

      const format = element.dataset.localTimeFormat || "date_time"
      element.textContent = this.formatDate(date, format)
    })
  }

  formatDate(date, format) {
    if (format === "date") {
      return new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(date)
    }

    if (format === "time") {
      return new Intl.DateTimeFormat(undefined, {
        hour: "numeric",
        minute: "2-digit"
      }).format(date)
    }

    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    }).format(date)
  }
}
